import unescapedText from 'I18n/utils/unescapedText';
import { unreachableFallback } from 'ui-product-approvals-common/utils/unreachableFallback';
export const getTranslatedApprovalType = approvalType => {
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      return unescapedText('productApprovals.approvalTypes.MARKETING_EMAIL');
    case 'BLOG_POST':
      return unescapedText('productApprovals.approvalTypes.BLOG_POST');
    case 'SITE_PAGE':
      return unescapedText('productApprovals.approvalTypes.SITE_PAGE');
    case 'LANDING_PAGE':
      return unescapedText('productApprovals.approvalTypes.LANDING_PAGE');
    case 'DEAL':
      return unescapedText('productApprovals.approvalTypes.DEAL');
    case 'KNOWLEDGE_ARTICLE':
      return unescapedText('productApprovals.approvalTypes.KNOWLEDGE_ARTICLE');
    case 'QUOTE':
      return unescapedText('productApprovals.approvalTypes.QUOTE');
    case 'SOCIAL_BROADCAST':
      return unescapedText('productApprovals.approvalTypes.SOCIAL_BROADCAST');
    case 'CONNECTED_APP':
      return unescapedText('productApprovals.approvalTypes.CONNECTED_APP');
    default:
      return unreachableFallback(approvalType, unescapedText('productApprovals.unhandled.approvalType'));
  }
};
export const getTranslatedApprovalTypeCapitalised = approvalType => {
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      return unescapedText('productApprovals.approvalTypesCapitalised.MARKETING_EMAIL');
    case 'BLOG_POST':
      return unescapedText('productApprovals.approvalTypesCapitalised.BLOG_POST');
    case 'SITE_PAGE':
      return unescapedText('productApprovals.approvalTypesCapitalised.SITE_PAGE');
    case 'LANDING_PAGE':
      return unescapedText('productApprovals.approvalTypesCapitalised.LANDING_PAGE');
    case 'DEAL':
      return unescapedText('productApprovals.approvalTypesCapitalised.DEAL');
    case 'KNOWLEDGE_ARTICLE':
      return unescapedText('productApprovals.approvalTypesCapitalised.KNOWLEDGE_ARTICLE');
    case 'QUOTE':
      return unescapedText('productApprovals.approvalTypesCapitalised.QUOTE');
    case 'SOCIAL_BROADCAST':
      return unescapedText('productApprovals.approvalTypesCapitalised.SOCIAL_BROADCAST');
    case 'CONNECTED_APP':
      return unescapedText('productApprovals.approvalTypesCapitalised.CONNECTED_APP');
    default:
      return unreachableFallback(approvalType, unescapedText('productApprovals.unhandled.approvalType'));
  }
};
export const getTranslatedApprovalTypePlural = approvalType => {
  switch (approvalType) {
    case 'MARKETING_EMAIL':
      return unescapedText('productApprovals.approvalTypesPlural.MARKETING_EMAIL');
    case 'BLOG_POST':
      return unescapedText('productApprovals.approvalTypesPlural.BLOG_POST');
    case 'SITE_PAGE':
      return unescapedText('productApprovals.approvalTypesPlural.SITE_PAGE');
    case 'LANDING_PAGE':
      return unescapedText('productApprovals.approvalTypesPlural.LANDING_PAGE');
    case 'DEAL':
      return unescapedText('productApprovals.approvalTypesPlural.DEAL');
    case 'KNOWLEDGE_ARTICLE':
      return unescapedText('productApprovals.approvalTypesPlural.KNOWLEDGE_ARTICLE');
    case 'QUOTE':
      return unescapedText('productApprovals.approvalTypesPlural.QUOTE');
    case 'SOCIAL_BROADCAST':
      return unescapedText('productApprovals.approvalTypesPlural.SOCIAL_BROADCAST');
    case 'CONNECTED_APP':
      return unescapedText('productApprovals.approvalTypesPlural.CONNECTED_APP');
    default:
      return unreachableFallback(approvalType, unescapedText('productApprovals.unhandled.approvalType'));
  }
};